var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('a',{staticClass:"text-center bottom-text",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v(" © 2021 smheee.com 长材智能运维-圣名远扬, All Rights Reserved.Email : shengming_tech@163.com Tel: 020-31802914 粤ICP备2021034595号-1  ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }